interface CheckoutCopy {
  brand: string;
  back: string;
  login: string;
  title: string;
  titleHighlight: string;
  introduction: string;
  progressLabel: string;
  steps: readonly string[];
  accessTitle: string;
  accountTitle: string;
  accountDescription: string;
  summaryLabel: string;
  summaryTitle: string;
  loadingTitle: string;
  loadingDescription: string;
  help: string;
  helpLink: string;
}

export const checkoutCopy: CheckoutCopy = {
  brand: "hey404",
  back: "Volver al curso",
  login: "Iniciar sesión",
  title: "Tu curso,",
  titleHighlight: "a un paso.",
  introduction: "Revisa tu selección y paga con tu correo.",
  progressLabel: "Pasos de la compra",
  steps: ["Correo", "Pago", "Acceso"],
  accessTitle: "Tus datos de acceso",
  accountTitle: "Tu cuenta",
  accountDescription: "El curso quedará vinculado a esta cuenta.",
  summaryLabel: "Resumen del pedido",
  summaryTitle: "Tu selección",
  loadingTitle: "Estamos revisando tu sesión.",
  loadingDescription: "En un momento podrás continuar con tu correo.",
  help: "¿Tienes alguna pregunta?",
  helpLink: "Escríbenos",
};
